(function () {
  const map = L.map("map", {
    preferCanvas: true,
    scrollWheelZoom: false
  }).setView(window.DeliveryData.fallbackCenter, window.DeliveryData.fallbackZoom);

  map.createPane("deliveryCoveragePane");
  map.getPane("deliveryCoveragePane").style.zIndex = 450;
  L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_2qx5_1_b66c3013589d87d8eff58ace", {
    maxZoom: 20,
    subdomains: "abcd",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
  }).addTo(map);

  const regionLayers = new Map();
  const regionDataByCode = new Map();
  let selectedLayer = null;
  let deliveryBounds = null;

  function getDeliveryColor() {
    const mapElement = document.getElementById("map");
    const cssColor = getComputedStyle(mapElement).getPropertyValue("--delivery-map-zone").trim();
    if (cssColor && cssColor !== "currentColor") return cssColor;
    return getComputedStyle(mapElement).color || window.DeliveryData.statusColors.active;
  }

  function styleFeature(feature) {
    const color = getDeliveryColor();
    return {
      color,
      fillColor: color,
      fillOpacity: 0,
      interactive: true,
      opacity: 0,
      pane: "deliveryCoveragePane",
      stroke: false,
      weight: 0
    };
  }

  function selectedStyle(feature) {
    const color = getDeliveryColor();
    return {
      color,
      fillColor: color,
      fillOpacity: 0.38,
      interactive: true,
      opacity: 0,
      pane: "deliveryCoveragePane",
      stroke: false,
      weight: 0
    };
  }

  function getCoverageLatLngs(geojson) {
    return geojson.features.flatMap((feature) => {
      const geometry = feature.geometry;
      if (!geometry) return [];
      if (geometry.type === "Polygon") {
        return [L.GeoJSON.coordsToLatLngs(geometry.coordinates, 1)];
      }
      if (geometry.type === "MultiPolygon") {
        return L.GeoJSON.coordsToLatLngs(geometry.coordinates, 2);
      }
      return [];
    });
  }

  function addCoverageOverlay(geojson) {
    const color = getDeliveryColor();
    L.polygon(getCoverageLatLngs(geojson), {
      color,
      fillColor: color,
      fillOpacity: 0.36,
      interactive: false,
      opacity: 0,
      pane: "deliveryCoveragePane",
      smoothFactor: 0,
      stroke: false,
      weight: 0
    }).addTo(map);

    geojson.features.forEach((feature) => {
      if (feature.geometry?.type !== "Point") return;
      const [lng, lat] = feature.geometry.coordinates;
      L.circle([lat, lng], {
        color,
        fillColor: color,
        fillOpacity: 0.36,
        interactive: false,
        opacity: 0,
        pane: "deliveryCoveragePane",
        radius: 1400,
        stroke: false,
        weight: 0
      }).addTo(map);
    });
  }

  function pointToLayer(feature, latlng) {
    const color = getDeliveryColor();
    return L.circleMarker(latlng, {
      color,
      fillColor: color,
      fillOpacity: 0.9,
      pane: "deliveryCoveragePane",
      radius: 9,
      weight: 3
    });
  }

  function pickupPointToLayer(location) {
    return L.marker([location.lat, location.lng], {
      icon: L.divIcon({
        className: "pickup-marker",
        html: `
          <span class="pickup-marker-pin" aria-hidden="true">
            <svg viewBox="0 0 24 24" focusable="false">
              <path d="M7 8h10l1 11H6L7 8Z"></path>
              <path d="M9 8a3 3 0 0 1 6 0"></path>
            </svg>
          </span>
        `,
        iconAnchor: [14, 34],
        iconSize: [28, 36],
        popupAnchor: [0, -34]
      }),
      keyboard: true,
      title: location.name,
      zIndexOffset: 1000
    });
  }

  function bindPickupLocation(location, layer) {
    layer.bindPopup(`
      <h3>${location.name}</h3>
      <p class="pickup-popup-address">${location.streetAddress}<br>${location.locality}</p>
      <p class="pickup-popup-time"><strong>Pickup Time at this location:</strong><br>${location.pickupTime}<br>(${location.orderCutoff})</p>
    `);
    layer.on("click", function () {
      layer.openPopup();
    });
  }

  function selectRegion(regionCode, options = {}) {
    const layer = regionLayers.get(regionCode);
    if (!layer) return false;

    if (selectedLayer) {
      selectedLayer.setStyle(styleFeature(selectedLayer.feature));
    }

    selectedLayer = layer;
    selectedLayer.setStyle(selectedStyle(layer.feature));
    selectedLayer.bringToFront();

    const region = layer.feature.properties;
    window.DeliveryUI.setResultForRegion(region, options.matchedCode || regionCode, {
      fullPostalCode: options.fullPostalCode === true
    });

    if (options.fitBounds !== false) {
      map.fitBounds(layer.getBounds(), {
        maxZoom: 12,
        padding: [24, 24]
      });
    }

    return true;
  }

  function getRegion(regionCode) {
    return regionDataByCode.get(regionCode);
  }

  function bindRegion(feature, layer) {
    const region = feature.properties;
    regionLayers.set(region.code, layer);

    layer.bindPopup(`
      <h3>${region.name}</h3>
      <p>${window.DeliveryData.statusLabels.active}</p>
    `);

    layer.on("click", function () {
      selectRegion(region.code, { fitBounds: false });
      layer.openPopup();
    });
  }

  const assetUrls = window.deliveryMapAssets || {};

  Promise.all([
    fetch(assetUrls.fsa).then((response) => response.json()),
    fetch(assetUrls.regions).then((response) => response.json()),
    fetch(assetUrls.pickupLocations).then((response) => response.json())
  ])
    .then(([geojson, regions, pickupLocations]) => {
      const regionsByCode = new Map(regions.map((region) => [region.code, region]));
      regions.forEach((region) => regionDataByCode.set(region.code, region));
      geojson.features.forEach((feature) => {
        const region = regionsByCode.get(feature.properties.code);
        feature.properties = {
          ...feature.properties,
          ...region
        };
      });

      addCoverageOverlay(geojson);

      const geojsonLayer = L.geoJSON(geojson, {
        className: "delivery-coverage-layer",
        pane: "deliveryCoveragePane",
        pointToLayer,
        smoothFactor: 0,
        style: styleFeature,
        onEachFeature: bindRegion
      }).addTo(map);

      const pickupLayer = L.layerGroup(
        pickupLocations.map((location) => {
          const marker = pickupPointToLayer(location);
          bindPickupLocation(location, marker);
          return marker;
        })
      ).addTo(map);

      deliveryBounds = geojsonLayer.getBounds();
      pickupLayer.eachLayer((layer) => {
        deliveryBounds.extend(layer.getLatLng());
      });

      map.fitBounds(deliveryBounds, {
        maxZoom: 11,
        padding: [8, 8]
      });
    })
    .catch((error) => {
      console.error("Unable to load delivery map data.", error);
      window.DeliveryUI.setNotFound("map data");
    });

  window.DeliveryMap = {
    getRegion,
    selectRegion
  };
})();
